import { signal } from "@preact/signals-core";
import { getApprovals, getApprovalsCount } from "@/api";
import type { DtoDeploymentResponse } from "@/api";
import { sdkCall } from "@/lib/sdk-helpers";

/**
 * The signed-in user's pending deployment approvals. The count drives the
 * Home badge and the Approvals tab (shown only to approvers); the list is
 * loaded when the tab opens. Refreshed on deployment_updated WS events.
 */
export interface ApprovalsState {
  count: number;
  isApprover: boolean;
  items: DtoDeploymentResponse[];
  isLoading: boolean;
}

export const approvals = signal<ApprovalsState>({
  count: 0,
  isApprover: false,
  items: [],
  isLoading: false,
});

export async function fetchApprovalSummary(): Promise<void> {
  const res = await sdkCall(
    "approval summary failed:",
    () => getApprovalsCount({ throwOnError: true }),
    null,
  );
  if (!res) return;
  approvals.value = {
    ...approvals.value,
    count: res.data?.count ?? 0,
    isApprover: res.data?.is_approver ?? false,
  };
}

export async function fetchApprovals(): Promise<void> {
  approvals.value = { ...approvals.value, isLoading: true };
  const res = await sdkCall(
    "approvals failed:",
    () => getApprovals({ throwOnError: true }),
    null,
  );
  const items = res?.data ?? [];
  approvals.value = {
    ...approvals.value,
    items,
    count: res ? items.length : approvals.value.count,
    isLoading: false,
  };
}
